/**
 * Charity detail page tab constants
 * Use these enums instead of hardcoded tab strings
 */

export enum CharityTabs {
  SUMMARY = 'summary',
  PROJECT = 'project',
  TEAM = 'team',
  CHAMPION = 'champion',
  FINANCIALS = 'financials',
  DOCUMENTS = 'documents',
  GALLERY = 'gallery',
}
